import React from 'react'
import { Typewriter } from 'react-typewriting-effect'
import '../sytles/Header.css'

const Header = () => {
    return (
        <h2 className="welcome">
            <Typewriter
              string='OSRS Bingo'
              delay={150}
              cursor='_'
              stopBlinkinOnComplete={false}
            />
        </h2>
    )
}

export default Header
